<template>
  <div class="bcc-search-input-wrapper">
    <input type="text" class="bcc-search-input" :placeholder="placeholder" @keyup.enter="doSearch('keyup')" v-model="inputContent" spellcheck="false">
    <bcc-icon class="search-input" type="ic_search_" @click="doSearch('click')" />
  </div>
</template>
<script>
import BccIcon from '../icon'

export default {
  name: 'BccSearchInput',
  components: {
    BccIcon
  },
  props: {
    placeholder: String,
    autocomplete: {
      type: Boolean,
      default: true
    },
    value: {
      required: false
    }
  },
  data () {
    return {
      inputContent: this.value
    }
  },
  watch: {
    value (val) {
      this.inputContent = val
    },
    inputContent (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    doSearch (event) {
      if (event === 'keyup' && !this.autocomplete) {
        return false
      }
      this.$emit('on-search', this.inputContent)
    }
  }
}
</script>
